import Vue from "vue";

import AccountProfile from "./AccountProfile.vue";

export function load() {
    const selector = "account-profile";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(AccountProfile, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
